import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import Layout from "../providers/Layout";
import { getLayoutProps } from "../services/serverSideRequests";
import { fetchApi } from "../services/requests";
import { Page, MainContent, Aside, PageHeader } from "../services/styles";
import { ArticleListBreadcrumbs } from "../components/Breadcrumbs/Breadcrumbs";
import BoxLegalAdvice from "../components/BoxLegalAdvice/BoxLegalAdvice";
import BoxBuySubscription from "../components/BoxBuySubscription/BoxBuySubscription";
import BoxNewsletter from "../components/BoxNewsletter/BoxNewsletter";
import Thumbnails from "../components/Thumbnails/Thumbnails";
import Collapse from "../components/Collapse/Collapse";
import { getPageTitleString } from "../services/strings";
import { v4 as uuidv4 } from "uuid";
import CookieModal from "../components/Cookies/Modal";
import Cookies from "js-cookie";
import { useRouter } from "next/router";

const Image = styled.img`
  width: auto;
  max-width: 100%;
  margin-bottom: 20px;
`;
const Container = styled.div`
  margin: 40px 0;
`;
const TextSite = ({
  navbarLinks,
  submenuLists,
  paths,
  mainCategories,
  importantArticles,
  site,
}) => {
  const {
    query: { textsite },
  } = useRouter();
  if (!site) {
    return null;
  }
  const { title, image, body, photos, sections } = site;
  const bodyRef = useRef();
  const [modal, setModal] = useState(false);
  const [firstCookieAgreement, setFirstCookieAgreement] = useState(() =>
    Boolean(Cookies.get("cookie_third_party"))
  );
  const [secondCookieAgreement, setSecondCookieAgreement] = useState(null);

  const openModal = useCallback(() => setModal(true), [setModal]);

  // handle modal button, which comes from rest API
  useEffect(() => {
    const modalBtn = bodyRef.current.querySelector(
      "[data-modal='cookie-modal']"
    )?.parentNode;
    if (modalBtn) {
      modalBtn.addEventListener("click", openModal);
    }
    return () => {
      if (modalBtn) {
        modalBtn.removeEventListener("click", openModal);
      }
    };
  }, [textsite]);

  return (
    <Layout
      navbarLinks={navbarLinks}
      paths={paths}
      submenuLists={submenuLists}
      mainCategories={mainCategories}
      importantArticles={importantArticles}
      metatagsData={{ title: getPageTitleString(title) || "" }}
    >
      <Page>
        <Aside>
          <BoxLegalAdvice />
          <BoxBuySubscription />
          <BoxNewsletter />
        </Aside>
        <MainContent>
          <ArticleListBreadcrumbs article={title} />
          <PageHeader>{title}</PageHeader>
          {image && <Image src={image} />}
          <div className="wysiwyg" ref={bodyRef}>
            {ReactHtmlParser(body)}
          </div>
          {sections.length ? (
            <Container>
              {sections.map((section) => (
                <Collapse
                  key={section.id}
                  title={section.title}
                  body={section.body}
                />
              ))}
            </Container>
          ) : null}
          {photos.length ? (
            <>
              <Header>Zdjęcia</Header>
              <Thumbnails images={photos} />
            </>
          ) : null}
        </MainContent>
      </Page>
      {modal && (
        <CookieModal
          setActiveModal={setModal}
          setFirstCookieAgreement={setFirstCookieAgreement}
          firstCookieAgreement={firstCookieAgreement}
          setSecondCookieAgreement={setSecondCookieAgreement}
        />
      )}
    </Layout>
  );
};

export async function getServerSideProps(context) {
  const layoutProps = await getLayoutProps();
  const { textsite } = context.params;
  const [siteResp] = await fetchApi({
    url: `pages-page/?slug=${textsite}&sites=12`,
  });
  if (siteResp && siteResp.count === 0) {
    const { res, params } = context;
    res.statusCode = 302;
    res.setHeader("Location", `/404`);
    return {
      props: {
        ...layoutProps,
      },
    };
  }

  const site = siteResp.results[0];
  return {
    props: {
      ...layoutProps,
      site: site,
    },
  };
}
export default TextSite;
